export default {
    getValidExtensions : (taskType, mimeTypes) => {

        let validExtensions = [];
        //let validFiles = [];
        let uniqueExtensions = [];
        //let validMimeTypes = Object.keys(context.state.validMimeTypes[t.type].mimeTypes).map((mt) => {
        let validMimeTypes = Object.keys(mimeTypes[taskType].mimeTypes).map((mt) => {
            let exts = mimeTypes[taskType]['mimeTypes'][mt];
            validExtensions = validExtensions.concat(exts);

            return mt;
        });

        validExtensions.forEach((ve) => {
            let i = uniqueExtensions.findIndex((ue) => {
                return ue == ve;
            })

            if (i == -1) {
                uniqueExtensions.push(ve);
            }
        });

        validExtensions = uniqueExtensions;

        return {validMimeTypes, validExtensions}
    },

    sanitize: (f) => {
        let lio = f.name.lastIndexOf('.');
        let name = f.name.slice(0, lio);
        let ext = f.name.slice(lio);
        let sanitized = name.replace(/[^a-zA-Z0-9]+/g, "_");

        return `${sanitized}${ext}`;
    }

}